import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getClinicFormsList } from '../../constants/editList';
import { checkMandatoryFields } from '../../helpers/checkMandatoryFields';
import { EditList, EditListItem, NotificationStyled } from './styles';
import { checkIsPageActive } from 'features/feature-edit-profile-settings/helpers/checkIsPageActive';
import { ReactComponent as InfoIcon } from 'applicaiton/assets/info.svg';
import { Props } from './models';

const MenuList: FC<Props> = ({
  activePage,
  setActivePage,
  clinicProfileData,
}) => {
  const { t } = useTranslation();

  const clinicsFormsList = getClinicFormsList(
    Number(clinicProfileData?.owner?.id),
  );
  const isClinicActive = clinicProfileData?.status === 'Active';
  const isRequiredFieldsFilled = checkMandatoryFields(clinicProfileData);

  return (
    <EditList>
      {clinicsFormsList.map((item, idx) => {
        const isPageActive = checkIsPageActive(idx, clinicProfileData || null);
        return (
          <EditListItem
            key={item}
            isActive={activePage === item}
            onClick={() => setActivePage(item)}
          >
            {t(`editProfileSettings.editProfileList.${item}`)}
            {!isPageActive && <InfoIcon />}
          </EditListItem>
        );
      })}
      {!isClinicActive && (
        <NotificationStyled>
          <InfoIcon />
          <p>
            {isRequiredFieldsFilled
              ? t('editProfileSettings.activate_instruction')
              : t('editProfileSettings.notification')}
          </p>
        </NotificationStyled>
      )}
    </EditList>
  );
};

export default MenuList;
